<template>
  <image
    v-if="!anonymousCrossOrigin"
    width="800"
    height="1000"
    :xlink:href='shadowLink'></image>
  <img v-else crossorigin="anonymous"
    :src="shadowLink"
  >
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Shadow',
  props: {
    product: {
      type: Object,
    },
    side: {
      type: String
    },
    gender: {
      type: String
    },
    anonymousCrossOrigin: {
      type: Boolean
    }
  },
  computed: {
    ...mapState(["endpoint"]),
    shadowLink() {
      if (!this.gender) return false
      return this.endpoint + this.product.backgrounds[`shadow_${this.gender.toLowerCase()}_${this.side}`]
    }

  }
}
</script>